import axios from "axios";

export default {
  namespaced: true,
  state: {
    revenue_summary_report: null,
    technician_performance_report: null,
    turnaround_time_report: null,
    monthly_trends_report: null,
    loading: false,
  },
  getters: {
    revenue_summary_report(state) {
      return state.revenue_summary_report;
    },
    technician_performance_report(state) {
      return state.technician_performance_report;
    },
    turnaround_time_report(state) {
      return state.turnaround_time_report;
    },
    monthly_trends_report(state) {
      return state.monthly_trends_report;
    },
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    SET_REVENUE_SUMMARY_REPORT(state, data) {
      state.revenue_summary_report = data;
    },
    SET_TECHNICIAN_PERFORMANCE_REPORT(state, data) {
      state.technician_performance_report = data;
    },
    SET_TURNAROUND_TIME_REPORT(state, data) {
      state.turnaround_time_report = data;
    },
    SET_MONTHLY_TRENDS_REPORT(state, data) {
      state.monthly_trends_report = data;
    },
    SET_LOADING(state, val) {
      state.loading = val;
    },
  },
  actions: {
    async get_revenue_summary_report({ commit }, params = {}) {
      commit("SET_LOADING", true);
      try {
        let response = await axios.get("/service_reports/revenue_summary", {
          params,
        });
        commit("SET_REVENUE_SUMMARY_REPORT", response.data);
        return response.data;
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async get_technician_performance_report({ commit }, params = {}) {
      commit("SET_LOADING", true);
      try {
        let response = await axios.get(
          "/service_reports/technician_performance",
          { params }
        );
        commit("SET_TECHNICIAN_PERFORMANCE_REPORT", response.data);
        return response.data;
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async get_turnaround_time_report({ commit }, params = {}) {
      commit("SET_LOADING", true);
      try {
        let response = await axios.get("/service_reports/turnaround_time", {
          params,
        });
        commit("SET_TURNAROUND_TIME_REPORT", response.data);
        return response.data;
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async get_monthly_trends_report({ commit }, params = {}) {
      commit("SET_LOADING", true);
      try {
        let response = await axios.get("/service_reports/monthly_trends", {
          params,
        });
        commit("SET_MONTHLY_TRENDS_REPORT", response.data);
        return response.data;
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
};
